import React from 'react';

const AboutPage = () => {
  return (
    <div className="bg-navy min-h-screen py-16">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">About EliteMed</h1>

        <div className="bg-navy-light border border-primary/20 rounded-lg shadow-md p-8 space-y-6">
          <p className="text-gray-600 text-lg leading-relaxed">
            Coming from a family of healthcare professionals, we’ve seen the dedication, long hours, and care that go into helping others. That connection makes what you do personal to us, and shapes what we want EliteMed to offer.
          </p>
          <p className="text-gray-600 text-lg leading-relaxed">
            Our goal is simple: help you find comfortable, practical scrubs that reflect your style and fit your budget. With styles for women and men and a choice of fabrics, colors, and fits, we aim to make getting ready for your workday a little easier.
          </p>
          <p className="text-gray-600 text-lg leading-relaxed">
            Thank you for letting EliteMed be part of your day.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;